import React, { useContext } from "react";
import { Button, Modal } from "react-bootstrap";
import ApplicationContext from "../../context/ApplicationContext";
import { IReceipt } from "../../types/IReceipt";
import { IReceiptData } from "../../types/IReceiptData";
import { generateGUID } from "../../helpers/Helper";

export interface IPrintReceiptModalProps {
  close(): void;
  show: boolean;
}

export const PrintReceiptModal: React.FC<IPrintReceiptModalProps> = (
  props: IPrintReceiptModalProps
): JSX.Element => {
  const context = useContext(ApplicationContext);
  const [printing, setPrinting] = React.useState(false);

  function closeModal() {
    props.close();
  }

  function getTotal() {
    let total = 0;
    context.Receipt.getRows().forEach((r) => {
      total += r.qty * r.price;
    });
    return total;
  }

  function print() {
    setPrinting(true);

    const rows = context.Receipt.getRows();
    const settings = context.Configuration.getSettings();

    const organisation = settings.organisation;

    const customer = context.Customer.getCustomer();
    const user = context.AuthenticatedUser.getUser().fullname;
    const transactionType = context.Receipt.getTransactionType();
    const paymentType = context.Receipt.getPaymentType();
    const receiptNumber = context.Receipt.getReceiptNumber();

    const table = context.Receipt.getTable();

    if (table !== undefined) {
      customer.name = table.description1;
    }

    let receipt: IReceipt = {
      id: 0,
      createdAt: new Date(),
      rows: rows,
      total: getTotal(),
      customerReceiptNumber: receiptNumber,
      organisation: organisation,
      customer: customer,
      transactionType: transactionType,
      paymentType: paymentType,
      user: user,
      endComment: organisation.endComment,
      enteredValue: "",
      changeGiven: "",
      printerSettings: settings.printers,
      table: table !== undefined ? table.toString() : "",
    };

    const receiptData: IReceiptData = {
      receipt: receipt,
      token: context.AuthenticatedUser.getToken(),
      tableUuid: generateGUID(),
    };

    const receiptJson = JSON.stringify(receiptData);
    var encodedStringBtoA = btoa(receiptJson);

    let url = "https://print.waepos.com/Default.aspx?id=" + 0;
    url += "&data=" + encodedStringBtoA;

    window.location.href = url;
    setPrinting(false);
  }

  const messageModal = (): JSX.Element => {
    return (
      <>
        <Modal show={props.show} onHide={() => closeModal()} size="sm">
          <Modal.Header closeButton>
            <Modal.Title>Print</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Button
                  variant="primary"
                  style={{ width: 200, height: 100 }}
                  onClick={() => print()}
                >
                  <h3>Print</h3>
                </Button>
              </div>
            </>
          </Modal.Body>
          <Modal.Footer className="modal-footer">
            <div className="mr-auto"></div>
            <div>
              <Button variant="success" size="lg" onClick={() => props.close()}>
                Close
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      </>
    );
  };

  return (
    <>
      <>{messageModal()}</>
    </>
  );
};
